/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Footer from "./../global/Footer";
import NavbarBottom from "./../global/NavbarBottom";
import ic_finger from "../../assets/images/pictures/icon/ic_finger_point_64px.svg";
// import ic_card from "../../assets/images/pictures/icon/ic_card_50px.svg";
import ic_usb from "../../assets/images/pictures/icon/ic_usb_50px.svg";
// import ic_credit_card from "../../assets/images/pictures/icon/ic_credit-card_50px.svg";
// import ic_sim from "../../assets/images/pictures/icon/ic_sim_50px.svg";
// import smart from "../../assets/images/logos/eids/smartid.png";
// import epara from "../../assets/images/logos/eids/eparakstsm.png";
// import audkenni from "../../assets/images/logos/eids/Audkenni.png";
// import norway from "../../assets/images/logos/eids/bankid.png";
// import sweden from "../../assets/images/logos/eids/BankID_logo-1.png";
// import ftn from "../../assets/images/logos/eids/ftn.png";
// import itme from "../../assets/images/logos/eids/itme.png";
// import mitid from "../../assets/images/logos/eids/mitid.png";
// import idin from "../../assets/images/logos/eids/idin.png";
import electronic from "../../assets/images/logos/eids/electronic.png";
// import e from "../../assets/images/logos/eids/eresidency.png";
import remote from "../../assets/images/logos/eids/remote_signing.png";
import VNeID from "../../assets/images/logos/eids/vneid.jpg";
import { useTranslation } from "react-i18next";
import internal from "../../assets/images/logos/eids/ISS.svg";

const EIDsContent = () => {
  const { t } = useTranslation();
  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div id="eids" style={{ marginBottom: "50px" }}>
        <div className="container">
          <div className="row text-center">
            <div className="col-md-12 intro text-center">
              <img
                width="64"
                height="64"
                src={ic_finger}
                className="mt-50"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="font-weight-bold font-48" data-sr="no reset">
                {t("eids.title")}
              </h2>
              <div className="text-center mw-700" data-sr="no reset">
                <p>
                  {t("eids.content1")}
                  {/* <a href="javascript:;"> {t("eids.here")}</a>. */}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-10 col-sm-offset-1">
              {/* <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        src={ic_credit_card}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p> {t("eids.national")}</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.national-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        src={ic_card}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>{t("eids.smart")}</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.smart-note")}</h4>
                  </div>
                </div>
              </div> */}
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        src={ic_usb}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>{t("eids.usbtoken")}</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.usbtoken-note")}</h4>
                  </div>
                </div>
              </div>
              {/* <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        src={ic_sim}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>Quantera</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.mobileid")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="52"
                        height="52"
                        src={smart}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>Smart-ID</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.smartid-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="50"
                        height="50"
                        src={epara}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>{t("eids.eParaksts")}</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.eParaksts-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="60"
                        height="58"
                        src={audkenni}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>{t("eids.audkenni")}</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.audkenni-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="50"
                        height="32"
                        src={norway}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>{t("eids.norway")} </p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.norway-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="60"
                        height="50"
                        src={sweden}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>{t("eids.sweden")} </p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.sweden-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="60"
                        height="49"
                        src={ftn}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>Finnish Trust Network (FTN)</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.FTN-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="60"
                        height="60"
                        src={itme}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>itsme</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.itsme-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="60"
                        height="60"
                        src={mitid}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>MitID</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.mitID-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="60"
                        height="60"
                        src={idin}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>iDIN</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.iDIN-note")}</h4>
                  </div>
                </div>
              </div> */}
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="52"
                        height="60"
                        src={remote}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>Remote Signing</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.remote-signing-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="52"
                        height="60"
                        src={electronic}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>Electronic IDentification</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.electronic-note")}</h4>
                  </div>
                </div>
              </div>
              {/* <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="60"
                        height="44"
                        src={swisscom}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>Swisscom</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.swisscom-note")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="60"
                        height="60"
                        src={e}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>e-Residency</p>
                      <a
                        className="btn-signup btn-learn"
                        href="/e-residency"
                        target=""
                      >
                        {t("eids.button")}
                      </a>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.e-note")}</h4>
                  </div>
                </div>
              </div> */}

              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="52"
                        height="60"
                        src={VNeID}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>VNeID</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.vneid")}</h4>
                  </div>
                </div>
              </div>
              <div className="panel">
                <div className="panel-body box">
                  <div className="col-md-4">
                    <div className="ic-box text-center">
                      <img
                        width="52"
                        height="60"
                        src={internal}
                        className="img-responsive"
                        alt=""
                        decoding="async"
                        loading="lazy"
                      />
                      <p>Internal Signing Service</p>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h4>{t("eids.internal")}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default EIDsContent;
